export default "__VITE_ASSET__Kz_PLVtf__"